module.exports = (rows, startTimes, endTimes) => {
    let css = '[tracks] 0.10fr'; // auto
    rows?.sort((a, b) => a - b).map((row) => {
        if(startTimes.includes(row)) {
            css += ' [time-' + row + '] .25fr'
        } else {
            css += ' [time-' + row + '] .01fr'
        }
    })
    return css;
}

/*module.exports = () => {
    let css = '[tracks] auto';
    const dailySeconcs = 86400;
    const interval = 60 * 5 // Every 5 minutes;
    for(let i = 0; i < (dailySeconcs/interval); i++) {
        let mins = i * 5;
        let hours = 0;
        while(mins % 60 === 0)  {
            hours++;
            mins -= 60;
        }
        css += ' [time-' + (hours < 10 ? '0' + hours : hours) + (mins < 10 ? '0' + mins : mins)  + '] 0.1fr'
    }
    console.log(css)
    return css;
}*/